// Do not add "use client". Imported by RSCLoggedOutFooter.tsx
import home from "@faire/web-api--source/routes/www/root";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import { FaireLogo } from "@faire/web/ui/logos/FaireLogo";
import React from "react";

export const FooterCTA: React.FC<{
  title: string | React.ReactNode;
  ctaContent: React.ReactNode;
  showLogoLink?: boolean;
}> = ({ title, ctaContent, showLogoLink }) => {
  return (
    <Column className="align-start w-full md:w-[430px] lg:w-[470px] xl:w-[670px]">
      {showLogoLink ? (
        <Link to={home()} className="pb-4">
          <FaireLogo className="w-[88px] md:w-[118px]" />
        </Link>
      ) : null}
      <Typography
        variant={{
          mobileAndAbove: "pageHeaderSerifRegular",
          desktopAndAbove: "displaySSerifRegular",
          xLargeAndAbove: "displayMSerifRegular",
        }}
      >
        {title}
      </Typography>
      <Spacer size="3x" />
      {ctaContent}
      <Spacer size={{ mobileAndAbove: "2x", tabletAndAbove: "0" }} />
    </Column>
  );
};
